export const BASE_URL = 'https://git-branch-m-main-git-remote-add-origin.onrender.com/api/v1' 